import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { MatrizTarifaDistanciaList } from "./distancias/list";
import { MatrizTarifaPesoList } from "./pesos/list";

type Entity = models.MatrizTarifa;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
}

/**
* Componente para editar los rangos de las tarifas
*/
export class Rangos extends React.PureComponent<Props> {
    private getField = kea.formfields(() => this.props);
    render() {
        const getField = this.getField;
        const { value, onChange } = this.props;

        const Distancias = getField(MatrizTarifaDistanciaList);
        const Pesos = getField(MatrizTarifaPesoList);

        return (
            <div>
                {kea.autogrid(6, [
                    <Distancias field="MatrizTarifaDistancias" />,
                    <Pesos field="MatrizTarifaPesos" />
                ])}
                
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matricestarifa/edit/componentes/rangos.tsx